/* eslint-disable jsx-a11y/alt-text */
import plus from "../../assets/images/plus.png";

export function MobileFooter() {
  return (
    <div className="my-10">
      <div
        className="flex justify-between mx-10 p-2"
        style={{ fontSize: "12px", color: "#3b5998" }}
      >
        <ul
          className="flex flex-col"
          style={{
            alignItems: "center",
            display: "flex",
            flexWrap: "wrap"
          }}
        >
          <li id="eng">English (US)</li>
          <li>नेपाली</li>
          <li>हिन्दी</li>
          <li>Español</li>
          <li>Português (Brasil)</li>
        </ul>
        <ul className="flex flex-col">
          <li>Deutsch</li>
          <li>Italiano</li>
          <li>中文(简体)</li>
          <li>
            <img src={plus} />
          </li>
        </ul>
      </div>
      <div
        className="flex justify-center items-center mt-5"
        style={{ fontSize: "10px", color: "#8a8d91", fontWeight: "600" }}
      >
        <p>
          About <span> · </span> Help <span> · </span> More
        </p>
      </div>
      <div
        className="flex justify-center items-center mt-4"
        style={{ fontSize: "12px", color: "#8a8d91", fontWeight: "600" }}
      >
        <p>Meta &copy; 2025</p>
      </div>
    </div>
  );
}
